import React, {useEffect, useState} from 'react';
import AutoComplete from '../../AutoComplete'
import {Col, FormControl, FormSelect, Row} from "react-bootstrap";
import {useStores} from "../../../stores/Context";
import {observer} from "mobx-react";
import {action} from "mobx";
import {
    getAllInfoContext,
    getAllSapsQueryByTotemID,
    getSaspQueryCOlumnNameById
} from "../../../utils/requests";
import {v4 as uuidv4} from "uuid";
import axios from "axios";
import PaletteCouleurs from "../../PaletteCouleurs";
import BtnSvg from "../../../boiteAOutils/BtnSvg";
import ModalInfos from "../../../boiteAOutils/ModalInfos";
import BtnAction from "../../../boiteAOutils/BtnAction";
import BtnPlus from "../../../boiteAOutils/BtnPlus";

const InfosIndicateur = (store, id_indicateur) => {
    const {widgetStore} = useStores();
    let result = widgetStore.widgetsAvailable.filter(widget => widget.idWidget === id_indicateur)[0].config;

    let listSeuils = result.listeSeuils;
    if (listSeuils.length === 0 || result.ind_misEnForme !== 'geometric') {
        listSeuils = [
            {"seu_couleur": "#E62222", "seu_sens": "inferieur", "seu_valeur": 100}
            , {"seu_couleur": "#3498DB", "seu_sens": "=", "seu_valeur": 100}
            , {"seu_couleur": "#37D67A", "seu_sens": "superieur", "seu_valeur": 100}
        ]
    }
    store.objetCalendrierSeuils = listSeuils;
    return listSeuils;
}


// Fonction pour modifier une variable dans le store
// Pour evite d'avoir ce warning :
//      [MobX] Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify
// exemple :
//      A la place de niveauxIndicateurStore.objetCalendrierSeuils = list
//      Store_setVariable(niveauxIndicateurStore, 'objetCalendrierSeuils', list)

const Store_setVariable = action((store, path, newValue) => {
    // console.log('STOREsetVariable', [
    //     store,
    //     path,
    //     newValue
    // ])
    const keys = Array.isArray(path) ? path : path.split('.');
    const lastKey = keys.pop();
    const target = keys.reduce((acc, key) => acc[key], store);
    target[lastKey] = newValue;
});

const CreateObjectCalendar = observer(({idObjet, data = null}) => {
    console.log('idObjet', idObjet)
    // si idObjet est undefined ou non
    if (idObjet === undefined || idObjet === null) {
        console.log('coucouc !!! !')
    }

    const {niveauxIndicateurStore, widgetStore} = useStores();
    const idTotem = widgetStore.idTotem;
    /* *** get key with value, cookies *** */
    const getKeyWithValueCookie = () => {
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            let keyAndValue = c.split('=');
            if (keyAndValue[1] === widgetStore._token) {
                return keyAndValue[0].replace("_apiToken", "");
            }
        }
        return null;
    }

    const [sourcesAvailable, setSourcesAvailable] = useState([]);
    const [sourcesManuelle, setSourcesManuelle] = useState([]);
    const [source, setSource] = useState(data ? data.config.cal_id_requete_sasp : '0');
    // const [sourcesObjectif, setSourcesObjectif] = useState([]);
    const [listInfoContext, setListInfoContext] = useState([]);
    const [dataColonnes, setDataColonnes] = useState([]);
    const [col, setCol] = useState([]);
    const [colAddErr, setColAddErr] = useState(false);
    const [textValue, setTextValue] = useState(data ? data?.config.cal_nom : '')
    const [textInfoCont, setTextInfoCont] = useState(data ? data?.config.infoContext[0].infos_context_titre : '')
    const [colInfoTitle, setColInfoTitle] = useState('')
    const [listeColInfo, setlisteColInfo] = useState([]);
    const [listeSeuils, setlisteSeuils] = useState(data ? data.config.listeSeuils : InfosIndicateur(niveauxIndicateurStore, niveauxIndicateurStore.idWidgetIndicateurOuvert));
    const ent = getKeyWithValueCookie()

    // handle input change
    const handleSeuilInputChange = (e, index) => {
        const {name, value} = e.target;
        const list = [...listeSeuils];
        if (name === "seu_valeur") {
            list[index][name] = value.replace(/[^0-9,]+/g, ''); // supprime l'intégralité des caractères autres que des chiffres ou une virgule
        } else {
            list[index][name] = value;
        }
        // niveauxIndicateurStore.objetCalendrierSeuils = list;
        Store_setVariable(niveauxIndicateurStore, 'objetCalendrierSeuils', list);
        setlisteSeuils(list);
    };

    const handleSeuilColorInputChange = (color, index) => {
        const colorSeuil = [...listeSeuils];
        colorSeuil[index]['seu_couleur'] = color;
        // niveauxIndicateurStore.objetCalendrierSeuils = colorSeuil;
        Store_setVariable(niveauxIndicateurStore, 'objetCalendrierSeuils', colorSeuil);
        setlisteSeuils(colorSeuil);
    }

    // handle click event of the Remove button
    const handleSeuilRemoveClick = index => {
        const list = [...listeSeuils];
        list.splice(index, 1);
        // niveauxIndicateurStore.objetCalendrierSeuils = list;
        Store_setVariable(niveauxIndicateurStore, 'objetCalendrierSeuils', list);
        setlisteSeuils(list);
    };

    // handle click event of the Add button
    const handleSeuilAddClick = () => {
        setlisteSeuils([...listeSeuils, {seu_couleur: "#000000", "seu_sens": "=", seu_valeur: "100"}]);
    };

    const handleGetText = (value) => {
        // niveauxIndicateurStore.objetCalendrierTitle = value;
        Store_setVariable(niveauxIndicateurStore, 'objetCalendrierTitle', value);
        setTextValue(value)
    }

    const handleGetInfoCont = (value) => {
        // niveauxIndicateurStore.objetCalInfoContTitle = value;
        Store_setVariable(niveauxIndicateurStore, 'objetCalInfoContTitle', value);
        // niveauxIndicateurStore.objetCalendrierIDInfosContext = '0';
        Store_setVariable(niveauxIndicateurStore, 'objetCalendrierIDInfosContext', '0');
        setTextInfoCont(value)
    }

    const handleChangeColSource = (e) => {
        const value = e.target.value;
        // niveauxIndicateurStore.objetCalendrierColSource = value;
        Store_setVariable(niveauxIndicateurStore, 'objetCalendrierColSource', value);
        let cols = niveauxIndicateurStore.objetTableauValue.colonne;

        setCol(cols.map((col, k) => {
            col.col_nom_sasp = value
            return col;
        }))

        // niveauxIndicateurStore.objetTableauValue.colonne = cols;
        Store_setVariable(niveauxIndicateurStore, 'objetTableauValue.colonne', cols);
    }

    const addColInfo = () => {
        if (colInfoTitle === '') {
            // function de validation de l'input
            setColAddErr(true);
        } else {
            let titleNewColInfo = colInfoTitle;
            let listCol = listeColInfo;
            listCol.push({colInfo_title: titleNewColInfo, colInfo_uuid: uuidv4()})
            // niveauxIndicateurStore.objetCalInfoColTableau = listCol;
            Store_setVariable(niveauxIndicateurStore, 'objetCalInfoColTableau', listCol);
            setlisteColInfo(listCol);
            setColInfoTitle('')
        }
    }

    const delColInfo = (uuidCol) => {
        let listCol = listeColInfo;
        listCol = listCol.filter((i) => i.colInfo_uuid !== uuidCol)
        // niveauxIndicateurStore.objetCalInfoColTableau = listCol;
        Store_setVariable(niveauxIndicateurStore, 'objetCalInfoColTableau', listCol);
        setlisteColInfo(listCol)
    }

    const onSelected = (value) => {
        let info = listInfoContext.filter(i => i.infos_context_titre === value)[0];
        // niveauxIndicateurStore.objetCalendrierIDInfosContext = info.id_infos_context;
        Store_setVariable(niveauxIndicateurStore, 'objetCalendrierIDInfosContext', info.id_infos_context);
        // niveauxIndicateurStore.objetCalInfoContTitle = value;
        Store_setVariable(niveauxIndicateurStore, 'objetCalInfoContTitle', value);
        // niveauxIndicateurStore.objetCalInfoColTableau = JSON.parse(info.infos_context_json_structure);
        Store_setVariable(niveauxIndicateurStore, 'objetCalInfoColTableau', JSON.parse(info.infos_context_json_structure));
        setlisteColInfo(JSON.parse(info.infos_context_json_structure))
    }

    useEffect(() => {
        const rqSaspColumn = async () => {
            const columns = await getSaspQueryCOlumnNameById(niveauxIndicateurStore.objetCalendrierIDSource, ent);
            setDataColonnes(columns);
        };

        const isSourceAvailable = sourcesAvailable.length > 0 || sourcesManuelle.length > 0;
        const sourceId = niveauxIndicateurStore.objetCalendrierIDSource;

        // console.log("Calendar__Logs::", isSourceAvailable, sourceId)
        if (isSourceAvailable && (sourceId !== '0')) {
            const foundSource = sourcesAvailable.find(source => {
                return source.id && source.id === sourceId;
            });
            const foundManualSource = sourcesManuelle.find(source => {
                return source.id_widget && source.id_widget === sourceId;
            });

            if (foundSource) {
                // niveauxIndicateurStore.objetCalendrierSourceType = null;
                Store_setVariable(niveauxIndicateurStore, 'objetCalendrierSourceType', null);
                rqSaspColumn();
            } else if (foundManualSource) {
                // niveauxIndicateurStore.objetCalendrierSourceType = 'Manuelle';
                Store_setVariable(niveauxIndicateurStore, 'objetCalendrierSourceType', 'Manuelle');
                setDataColonnes(['valeur_saisie', 'date_saisie']);
            } else {
                // niveauxIndicateurStore.objetCalendrierSourceType = null;
                Store_setVariable(niveauxIndicateurStore, 'objetCalendrierSourceType', null);
                Store_setVariable(niveauxIndicateurStore, 'objetCalendrierIDSource', '0');
                setDataColonnes([]);
            }
        } else {
            setDataColonnes([]);
        }
    }, [niveauxIndicateurStore.objetCalendrierIDSource, ent, niveauxIndicateurStore, sourcesAvailable, sourcesManuelle]);

    useEffect(() => {
        if (data?.config.infoContext && listInfoContext.length > 0) {
            onSelected(data.config.infoContext[0].infos_context_titre)
        } else {
            // niveauxIndicateurStore.objetCalendrierIDInfosContext = '0'
            Store_setVariable(niveauxIndicateurStore, 'objetCalendrierIDInfosContext', '0');
        }
    }, [listInfoContext, data, niveauxIndicateurStore]);

    useEffect(() => {
        // niveauxIndicateurStore.objetCalendriercolInfoTitle = colInfoTitle
        Store_setVariable(niveauxIndicateurStore, 'objetCalendriercolInfoTitle', colInfoTitle)
    }, [colInfoTitle, niveauxIndicateurStore]);

    useEffect(() => {
        const rqSaps = async () => {
            let sources = await getAllSapsQueryByTotemID(idTotem, ent);
            setSourcesAvailable(sources)
        }
        const rqIndManuel = async () => {
            let sources = await axios.get(process.env.REACT_APP_API_URL + '/api/saisie/list/' + ent,
                {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
            );
            setSourcesManuelle(sources.data)
        }
        // const objectifsData = async () => {
        //     let data = await getAllListObjectif(idTotem, ent);
        //     setSourcesObjectif(data)
        // }
        const allInfoContext = async () => {
            let listInfoCont = await getAllInfoContext(ent);
            setListInfoContext(listInfoCont)
        }

        if (data !== null) {
            // niveauxIndicateurStore.objetCalendrierIDSource = data.config.cal_id_requete_sasp
            Store_setVariable(niveauxIndicateurStore, 'objetCalendrierIDSource', data.config.cal_id_requete_sasp);
            // niveauxIndicateurStore.objetCalendrierTitle = data.config.cal_nom
            Store_setVariable(niveauxIndicateurStore, 'objetCalendrierTitle', data.config.cal_nom);
            // niveauxIndicateurStore.objetCalendrierIDSourceObj = data.config.cal_id_list_objectif
            Store_setVariable(niveauxIndicateurStore, 'objetCalendrierIDSourceObj', data.config.cal_id_list_objectif);
            // niveauxIndicateurStore.objetCalendrierColSource = data.config.cal_col_requete_sasp
            Store_setVariable(niveauxIndicateurStore, 'objetCalendrierColSource', data.config.cal_col_requete_sasp);
            // niveauxIndicateurStore.objetCalendrierSeuils = data.config.listeSeuils
            Store_setVariable(niveauxIndicateurStore, 'objetCalendrierSeuils', data.config.listeSeuils);
        }
        rqSaps();
        rqIndManuel();
        // objectifsData();
        allInfoContext();
    }, [data, idTotem, ent, niveauxIndicateurStore, widgetStore]);

    useEffect(() => {
        setSource(niveauxIndicateurStore.objetCalendrierIDSource)
    }, [niveauxIndicateurStore.objetCalendrierIDSource]);


    const styles = {
        label: {
            color: 'var(--SEIZO-dark, #002335)',
            fontFamily: '"Sofia Pro", serif',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            textAlign: 'left'
        },
        input: {
            display: 'inline-flex',
            padding: '12px 18px',
            marginBottom: '1em',
            alignItems: 'flex-start',
            gap: '18px',
            borderRadius: '4px',
            border: '1px solid var(--icon-black, #002335)',
            backgroundColor: 'var(--icon-light-BG, #FBFDFE)',
            /* font styles */
            color: 'var(--icon-black, #002335)',
            fontFamily: 'Nunito, serif',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '130%',
        }
    }

    return (
        <div style={{overflowX: 'hidden', display: "flex", flexDirection: "column", gap: "20px"}}>
            <div style={{textAlign: "left"}}>
                <label style={styles.label}>Titre</label>
                <FormControl style={styles.input} type={"text"} value={textValue} onChange={(e) => {
                    handleGetText(e.target.value)
                }}/>
            </div>

            <div style={{textAlign: "left"}}>
                <label style={styles.label}>Source de donnée</label>
                <FormSelect value={source} className={""}
                            style={styles.input}
                            onChange={
                                (e) => {
                                    console.log('e.target.value', e.target.value)
                                    Store_setVariable(niveauxIndicateurStore, 'objetCalendrierIDSource', e.target.value);
                                    col.col_nom_sasp = 0
                                    setCol(col);
                                }}
                >
                    <option value={0}>Choisir la source de données</option>
                    <optgroup style={{fontWeight: 'bold', fontStyle: 'italic'}} label={"Saisies manuelles"}/>
                    {
                        sourcesManuelle.length === 0 ? (
                            <option value={0} disabled={true}>Aucune source manuelle disponible</option>
                        ) : (
                            sourcesManuelle.map((data) => (
                                data.disabled ? (
                                    <option key={data.id_widget} value={data.id_widget} disabled={true}>(Déjà utilisé)
                                        - {data.nom_list_saisie}</option>
                                ) : (
                                    <option key={data.id_widget} value={data.id_widget}>{data.nom_list_saisie}</option>
                                )
                            ))
                        )
                    }
                    <optgroup style={{fontWeight: 'bold', fontStyle: 'italic'}} label={"YDOS"}/>
                    {
                        sourcesAvailable.length === 0 ? (
                                <option value={0} disabled={true}>Aucune source YDOS disponible</option>) :
                            sourcesAvailable.map((source) => (
                                <option value={source.id}>{source.nom}</option>
                            ))
                    }
                </FormSelect>
                {
                    (niveauxIndicateurStore.objetCalendrierIDSource !== '0') && (
                        <Row className={'mb-2'}>
                            <Col xs={3}>
                                <h6>Colonnes</h6>
                            </Col>
                            <Col xs={9}>
                                {/*<FormSelect value={data === null ? col.col_nom_sasp : data.config.cal_col_requete_sasp } id={""} className={""} onChange={(e) => handleChangeColSource(e)} >*/}
                                <FormSelect value={niveauxIndicateurStore.objetCalendrierColSource} id={""} className={""}
                                            onChange={(e) => handleChangeColSource(e)}>
                                    <option value={0}>Choisir une donnée</option>
                                    {
                                        dataColonnes.map((data) => (
                                            <option value={data}>{data}</option>
                                        ))
                                    }
                                </FormSelect>
                            </Col>
                        </Row>
                    )
                }
            </div>

            <div className="sous_titre">
                <div className="contenu">
                    <span>Seuils</span>
                </div>
                <div className="line"></div>
            </div>
            <div className={"listeSeuils"}>
                {
                    listeSeuils.map((SEUIL, i) => {
                        return (
                            <div className={"element"}>
                                <PaletteCouleurs defaultColor={SEUIL.seu_couleur}
                                                 onColorChange={(e) => handleSeuilColorInputChange(e, i)}/>

                                <FormSelect name={"seu_sens"} value={SEUIL.seu_sens}
                                            onChange={e => handleSeuilInputChange(e, i)}>
                                    <option value="inferieur">&lt;</option>
                                    <option value="inferieur_egal">&lt;=</option>
                                    <option value="superieur">&gt;</option>
                                    <option value="superieur_egal">&gt;=</option>
                                    <option value="=">=</option>
                                </FormSelect>

                                <FormControl className={styles.input_add_widget}
                                             value={SEUIL.seu_valeur}
                                             name={"seu_valeur"}
                                             onChange={e => handleSeuilInputChange(e, i)}
                                />

                                {listeSeuils.length !== 1 &&
                                    <BtnSvg svg={"corbeille"} width={20} height={20}
                                            onClick={() => handleSeuilRemoveClick(i)}/>
                                }
                            </div>
                        )
                    })
                }

                <div><BtnAction onClick={handleSeuilAddClick}>+ Ajouter un seuil</BtnAction></div>
            </div>

            <div className="sous_titre">
                <div className="contenu">
                    <span>Infos Contextuelles</span>
                </div>
                <div className="line"></div>
            </div>

            {(idObjet === undefined) && (
                <div>
                    <label style={styles.label}>Info existante</label>
                    <FormSelect
                        name={"seu_sens"} value={niveauxIndicateurStore.objetCalendrierIDInfosContext}
                        onChange={(e) => {
                            if (e.target.value === 'null') {
                                Store_setVariable(niveauxIndicateurStore, 'objetCalendrierIDInfosContext', '0');
                                Store_setVariable(niveauxIndicateurStore, 'objetCalInfoContTitle', '');
                                Store_setVariable(niveauxIndicateurStore, 'objetCalInfoColTableau', []);
                                setlisteColInfo([]);
                                setTextInfoCont('');
                            } else {
                                const info = listInfoContext.filter(i => i.id_infos_context === e.target.value)[0];
                                Store_setVariable(niveauxIndicateurStore, 'objetCalendrierIDInfosContext', info.id_infos_context);
                                Store_setVariable(niveauxIndicateurStore, 'objetCalInfoContTitle', info.infos_context_titre);
                                Store_setVariable(niveauxIndicateurStore, 'objetCalInfoColTableau', JSON.parse(info.infos_context_json_structure));
                                setlisteColInfo(JSON.parse(info.infos_context_json_structure));
                                setTextInfoCont(info.infos_context_titre);
                            }
                        }}
                    >
                        <option value="null">Veuillez choisir une info contextuelle</option>
                        {
                            listInfoContext.map((data) => (
                                <option value={data.id_infos_context}>{data.infos_context_titre}</option>
                            ))
                        }
                    </FormSelect>
                </div>
            )}

            <div>
                {(niveauxIndicateurStore.objetCalendrierIDInfosContext === '0' || data !== null) && (
                    <>
                        <label style={styles.label}>Titre</label>
                        {/*<AutoComplete*/}
                        {/*    pholder="Titre de l'info contextuel"*/}
                        {/*    data={listInfoContext}*/}
                        {/*    value={textInfoCont}*/}
                        {/*    onSelected={onSelected}*/}
                        {/*    disabled={idObjet !== undefined}*/}
                        {/*    onChange={handleGetInfoCont}*/}
                        {/*/>*/}
                        <FormControl
                            type={'text'}
                            placeholder={"Titre de l'info contextuel"}
                            value={textInfoCont}
                            disabled={idObjet !== undefined}
                            onChange={(e) => handleGetInfoCont(e.target.value)}
                        />
                    </>
                )}
            </div>

            <div>
                {(niveauxIndicateurStore.objetCalendrierIDInfosContext === '0' || data !== null) && (
                    <div className={"flex flex-col gap-2 items-start"}>
                        <FormControl type={"text"} value={'Date'} disabled={true}/>
                        {
                            listeColInfo.map(col => {
                                return (
                                    <div className={"flex flex-row gap-2"}>
                                        <FormControl type={"text"} value={col.colInfo_title} disabled/>
                                        <BtnSvg svg={"corbeille"} width={20} height={20} onClick={() => {
                                            delColInfo(col.colInfo_uuid)
                                        }}/>
                                    </div>
                                )
                            })
                        }
                        <div className={"flex flex-row gap-2"}>
                            <FormControl type={"text"} placeholder={'Nom de la colonne'}
                                         style={colAddErr === true ? {borderColor: 'rgb(239 68 68)'} : {}}
                                         onChange={(e) => setColInfoTitle(e.target.value)}
                                         value={colInfoTitle}/>
                            {colAddErr === true ? <span className={'text-xs text-red-500 text-left'}>Veuillez renseigner un nom.</span> : ""}

                            <div onClick={() => {
                                addColInfo()
                            }}>
                                {/*+ Ajouter une colonne*/}
                                <BtnPlus/>
                            </div>
                        </div>
                        {/*<FormControl type={"text"} placeholder={'Nom de la colonne'}*/}
                        {/*             style={colAddErr === true ? {borderColor: 'rgb(239 68 68)'} : {}}*/}
                        {/*             onChange={(e) => setColInfoTitle(e.target.value)}*/}
                        {/*             value={colInfoTitle}/>*/}
                        {/*{colAddErr === true ?*/}
                        {/*    <span className={'text-xs text-red-500 text-left'}>Veuillez renseigner un nom.</span> : ""}*/}
                        {/*<div>*/}
                        {/*    <BtnAction onClick={() => {*/}
                        {/*        addColInfo()*/}
                        {/*    }}>*/}
                        {/*        /!*+ Ajouter une colonne*!/*/}
                        {/*        <BtnPlus/>*/}
                        {/*    </BtnAction>*/}
                        {/*</div>*/}
                    </div>
                )}
            </div>
        </div>
    );
});

export default CreateObjectCalendar;
